
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2591',
  depVersions: {
  "customer-portal-app": "static-1.2591",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.479",
  "data-fetching-client": "static-1.9756",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25651",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5685",
  "hs-test-utils": "static-1.8112",
  "hub-http": "static-1.6315",
  "hub-http-shared-msw-handlers": "static-1.10189",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18486",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11568",
  "I18n": "static-7.1634",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6555",
  "payment-link-components": "static-1.23761",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7144",
  "quartz-core": "static-1.6363",
  "quartz-i18n": "static-1.819",
  "react": "static-7.187",
  "react-colorpicker": "static-2.10302",
  "react-dlb": "static-1.80",
  "react-utils": "static-2.5411",
  "rich-text-lib": "static-1.19986",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18127",
  "ui-components-test-utils": "static-1.5705",
  "UIComponents": "static-3.8514",
  "foundations-assets": "static-1.4963",
  "foundations-components": "static-1.8113",
  "foundations-theming": "static-1.4526",
  "foundations-theming-specialty": "static-1.2242",
  "framer-motion": "static-1.73",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1133",
  "quartz-config": "static-1.922",
  "quartz-routing": "static-1.574",
  "quick-fetch": "static-1.3985",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16776",
  "rpc-client-utils": "static-1.4750",
  "sanitize-text": "static-1.8239",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.56",
  "ui-addon-draggable": "static-3.4856",
  "ui-addon-react-router-dom": "static-1.9634",
  "usage-tracker": "static-1.7442",
  "usage-tracker-anonymous": "static-1.5859",
  "usage-tracker-core": "static-1.7292",
  "video-components-external": "static-1.11576",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3468",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3421",
  "quartz-webpack": "static-1.3368",
  "bend-plugin-quartz-routing": "static-1.222",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.83",
  "customer-data-objects": "static-1.7772",
  "frontend-preferences-client": "static-1.8020",
  "laboratory-lib": "static-3.7249",
  "onboarding-scopes": "static-1.6556",
  "seat-types-lib": "static-1.228",
  "ui-addon-opt": "static-4.8454",
  "HeadJS": "static-2.766",
  "hs-test-utils-bend-plugin": "static-1.3223",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.149",
  "ts-schema": "static-1.4148",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7898",
  "cssUtils": "static-1.817",
  "customer-data-ui-utilities": "static-1.9920",
  "HubStyle": "static-2.11875",
  "knowledge-content-types": "static-1.8557",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.489",
  "ui-addon-emoji-picker": "static-1.9981",
  "ui-addon-i18n": "static-1.11245",
  "ui-business-units-lib": "static-1.9156",
  "ui-shepherd-react": "static-3.10316",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4420",
  "commerce-tours-lib": "static-1.6269",
  "customer-data-properties": "static-1.51903",
  "getting-started-shared-tasks": "static-1.18668",
  "growth-onboarding-reliability": "static-1.5175",
  "onboarding-tours": "static-1.16772",
  "reference-resolvers-lite": "static-1.8192",
  "sales-checkout-service-client": "static-1.3689",
  "ui-addon-iframeable": "static-1.9158",
  "user-context": "static-1.5204",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.841",
  "hubspotter-http": "static-1.4719",
  "icons": "static-2.651",
  "mobile-manifest-mixins": "static-1.540",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.819",
  "quartz-head": "static-1.809",
  "quartz-test": "static-1.819",
  "quartz-tracking": "static-1.523",
  "trellis-components": "static-1.2183",
  "ui-fonts": "static-1.830",
  "usage-tracker-container": "static-1.7432",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9516",
  "data-token-picker": "static-1.16565",
  "FileManagerLib": "static-1.39493",
  "property-translator": "static-1.5490",
  "atom": "static-1.5169",
  "merchandise-lib": "static-1.265",
  "purchase-motions-components": "static-1.6061",
  "salesImages": "static-1.526",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5596",
  "react-create-root-preference": "static-1.32",
  "react-select-plus": "static-1.106",
  "react-virtualized": "static-2.100",
  "ui-images": "static-2.1175",
  "bend-plugin-foundations-components": "static-1.4382",
  "floating-ui": "static-1.57",
  "react-aria": "static-1.67",
  "trellis-assets": "static-1.2164",
  "bend-plugin-foundations-theming": "static-1.3009",
  "foundations-theming-base": "static-1.3511",
  "stylex": "static-1.34",
  "interframe": "static-3.4854",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5856",
  "web-vitals": "static-1.7",
  "bend-plugin-chirp-manifest": "static-1.160",
  "chirp-fetch": "static-1.1981",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4571",
  "react-flip-move": "static-1.72",
  "apollo-link-hub-http": "static-2.4747",
  "content-media-composition-data-lib": "static-1.12601",
  "content-media-compositions": "static-2.16608",
  "idb-keyval": "static-1.45",
  "immer": "static-1.33",
  "immerable": "static-1.4248",
  "magpie-lib": "static-1.5611",
  "magpie-types": "static-1.5071",
  "media-bridge-lib": "static-1.19082",
  "video-data-lib": "static-1.35234",
  "bender-build-tools": "static-1.3278",
  "inbound-db-properties-service-client": "static-1.3913",
  "superstore": "static-1.4854",
  "feedback-loader": "static-1.29465",
  "ai-components-ui-library": "static-1.9186",
  "ui-addon-video-player": "static-1.8797",
  "ui-coaching-tips": "static-1.28818",
  "sassPrefix": "static-1.157",
  "react-dnd-compat": "static-1.4708",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2591",
  "navigation-messaging": "static-1.7572",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8268",
  "reselect": "static-2.16",
  "commerce-products-lib": "static-1.9879",
  "crm-message-bus": "static-1.43221",
  "growth-data-modal": "static-1.5575",
  "hubspot-apollo-client": "static-1.4972",
  "onboarding-tours-client": "static-1.4986",
  "calling-global-api": "static-1.64832",
  "calling-internal-common": "static-1.31404",
  "calling-lifecycle-internal": "static-1.66214",
  "calling-lifecycle-messages": "static-1.58508",
  "conditional-properties-service-client": "static-1.3865",
  "crm-links": "static-1.6400",
  "crm-pipelines-api-client-types": "static-1.4206",
  "customer-data-objects-ui-components": "static-1.13125",
  "customer-data-properties-shared-msw-handlers": "static-1.9516",
  "customer-data-property-utils": "static-1.8190",
  "external-options-client-types": "static-1.4199",
  "file-manager-components": "static-1.23853",
  "framework-data-schema-resolvers": "static-1.6984",
  "google-libphonenumber": "static-1.39",
  "hs-resources": "static-1.269",
  "inbound-db-meta-service-client": "static-1.3654",
  "inbounddb-objects-service-types": "static-1.4289",
  "meetings-icalendar-utils-lib": "static-1.728",
  "multi-currency-client-types": "static-1.3758",
  "object-builder-ui-client": "static-1.49065",
  "pipeline-validation-client-types": "static-1.4034",
  "property-value-citations": "static-1.2517",
  "pulse": "static-1.690",
  "smart-property-lib": "static-1.7661",
  "tiered-pricing": "static-1.1427",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11083",
  "growth-onboarding-confetti": "static-1.3160",
  "growth-onboarding-next-action-utils": "static-1.2191",
  "navigation-components": "static-1.18245",
  "onboarding-tours-utils": "static-1.838",
  "ui-shepherd-tracker": "static-1.7697",
  "ui-universal-auth": "static-1.9089",
  "batch-promise": "static-1.1636",
  "getting-started-shared-tasks-store": "static-1.17786",
  "hubspotter-http-shared-msw-handlers": "static-1.10187",
  "usage-tracker-session-replay": "static-1.5128",
  "base-ui": "static-1.12",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1034",
  "tanstack-virtual": "static-1.31",
  "audio-components": "static-1.6057",
  "FileManagerCore": "static-1.39352",
  "FileManagerImages": "static-1.37004",
  "video-components": "static-1.13578",
  "foundations-components-legacy": "static-1.1138",
  "purchase-motions-api": "static-1.6064",
  "signup-constants": "static-1.19055",
  "signup-ui-url-generator": "static-2.8152",
  "usage-tracker-public": "static-1.7253",
  "reactive-lib": "static-1.820",
  "simple-logging-lib": "static-1.3145",
  "chatspot-core": "static-1.21736",
  "ContentUtils": "static-1.68623",
  "copilot-toolkit": "static-1.11370",
  "growth-onboarding-feedback-components": "static-1.6673",
  "commerce-permissions": "static-1.871",
  "customer-data-tracking": "static-1.6984",
  "products-iframe-lib": "static-1.8181",
  "products-ui-components-shared-msw-handlers": "static-1.10571",
  "restore-request-side-panel-lib": "static-1.1108",
  "onboarding-data-sync-lib": "static-1.2118",
  "hubspot-apollo-cache": "static-1.431",
  "calling-error-reporting": "static-1.31411",
  "shared-worker-versioning": "static-1.11130",
  "calling-usage-tracker": "static-1.6637",
  "voice-sms-access-library": "static-1.1353",
  "conversations-skeleton-state": "static-1.7344",
  "location-customization-utils-lib": "static-1.9529",
  "fdsr-migration-layer": "static-1.103",
  "framework-builder-read-service-client": "static-1.4073",
  "framework-data-schema-quick-fetch": "static-1.6889",
  "persist-promise": "static-1.3793",
  "event-emitter": "static-1.1043",
  "bend-plugin-pulse": "static-1.193",
  "fast-json-patch": "static-1.64",
  "data-agent-kit": "static-1.342",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10272",
  "fsm": "static-1.3823",
  "policy-lib": "static-1.6874",
  "react-tinymce": "static-1.55489",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10335",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54615",
  "tinymce-plugins": "static-1.57729",
  "tinymce-themes": "static-1.56585",
  "growth-onboarding-next-action-components": "static-1.2219",
  "user-context-client": "static-1.4678",
  "nest": "static-1.325",
  "unified-auth-core-lib": "static-1.885",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4631",
  "video-embed": "static-1.36068",
  "content-icons-ui": "static-1.2251",
  "social-insights-client-types": "static-1.22301",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4907",
  "integrations-lib": "static-1.16456",
  "underscore": "static-1.8",
  "breeze-engine-lib": "static-1.1023",
  "sales-views-client-types": "static-1.4351",
  "InboxConnectUtils": "static-4.15055",
  "meetings-connect-utils-lib": "static-1.7698",
  "calling-orchestration-schema": "static-1.36130",
  "crm-record-cards-service-types": "static-1.3658",
  "highcharts": "static-8.105",
  "trellis-story-utils": "static-1.4607",
  "storybook-react": "static-1.34",
  "hub-http-contrib": "static-1.3136",
  "tinymce-data": "static-1.40700",
  "ui-addon-sales-email": "static-1.5304",
  "codemirror": "static-5.96",
  "layout-dnd-components": "static-1.12618",
  "layout-dnd-utils": "static-1.11593",
  "react-codemirror": "static-1.10722",
  "ui-brand-identity-lib": "static-1.15604",
  "NamespacedHubStyle": "static-2.9126",
  "outpost": "static-1.4265",
  "flux-actions": "static-1.343",
  "integrations-error-boundary-lib": "static-1.13871",
  "integrations-tracking-lib": "static-1.5700",
  "native-integrations-shared-strings": "static-1.7876",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10457",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.603",
  "breeze-engine-core": "static-1.301",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68698",
  "layout-data-lib": "static-1.9918",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.3111",
  "ads-unified-auth-lib": "static-1.294",
  "google-sheets-integration-lib": "static-1.511",
  "microsoft-drive-integration-lib": "static-1.648",
  "slack-ui-library": "static-1.10488",
  "advanced-menus-core": "static-1.15277",
  "advanced-menus-lib": "static-1.12192",
  "ExportDialog": "static-6.10475",
  "ui-memberships-settings-lib": "static-1.34295",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15276",
  "simple-menus-lib": "static-1.16793"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2591",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.479",
  "data-fetching-client": "/data-fetching-client/static-1.9756",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25651",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5685",
  "hs-test-utils": "/hs-test-utils/static-1.8112",
  "hub-http": "/hub-http/static-1.6315",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10189",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18486",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11568",
  "I18n": "/I18n/static-7.1634",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6555",
  "payment-link-components": "/payment-link-components/static-1.23761",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7144",
  "quartz-core": "/quartz-core/static-1.6363",
  "quartz-i18n": "/quartz-i18n/static-1.819",
  "react": "/react/static-7.187",
  "react-colorpicker": "/react-colorpicker/static-2.10302",
  "react-dlb": "/react-dlb/static-1.80",
  "react-utils": "/react-utils/static-2.5411",
  "rich-text-lib": "/rich-text-lib/static-1.19986",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18127",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5705",
  "UIComponents": "/UIComponents/static-3.8514",
  "foundations-assets": "/foundations-assets/static-1.4963",
  "foundations-components": "/foundations-components/static-1.8113",
  "foundations-theming": "/foundations-theming/static-1.4526",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2242",
  "framer-motion": "/framer-motion/static-1.73",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1133",
  "quartz-config": "/quartz-config/static-1.922",
  "quartz-routing": "/quartz-routing/static-1.574",
  "quick-fetch": "/quick-fetch/static-1.3985",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16776",
  "rpc-client-utils": "/rpc-client-utils/static-1.4750",
  "sanitize-text": "/sanitize-text/static-1.8239",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.56",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4856",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9634",
  "usage-tracker": "/usage-tracker/static-1.7442",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5859",
  "usage-tracker-core": "/usage-tracker-core/static-1.7292",
  "video-components-external": "/video-components-external/static-1.11576",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3468",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3421",
  "quartz-webpack": "/quartz-webpack/static-1.3368",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.222",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.83",
  "customer-data-objects": "/customer-data-objects/static-1.7772",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8020",
  "laboratory-lib": "/laboratory-lib/static-3.7249",
  "onboarding-scopes": "/onboarding-scopes/static-1.6556",
  "seat-types-lib": "/seat-types-lib/static-1.228",
  "ui-addon-opt": "/ui-addon-opt/static-4.8454",
  "HeadJS": "/HeadJS/static-2.766",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3223",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.149",
  "ts-schema": "/ts-schema/static-1.4148",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7898",
  "cssUtils": "/cssUtils/static-1.817",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9920",
  "HubStyle": "/HubStyle/static-2.11875",
  "knowledge-content-types": "/knowledge-content-types/static-1.8557",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9981",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11245",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9156",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10316",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4420",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6269",
  "customer-data-properties": "/customer-data-properties/static-1.51903",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18668",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5175",
  "onboarding-tours": "/onboarding-tours/static-1.16772",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8192",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3689",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9158",
  "user-context": "/user-context/static-1.5204",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.841",
  "hubspotter-http": "/hubspotter-http/static-1.4719",
  "icons": "/icons/static-2.651",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.540",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.819",
  "quartz-head": "/quartz-head/static-1.809",
  "quartz-test": "/quartz-test/static-1.819",
  "quartz-tracking": "/quartz-tracking/static-1.523",
  "trellis-components": "/trellis-components/static-1.2183",
  "ui-fonts": "/ui-fonts/static-1.830",
  "usage-tracker-container": "/usage-tracker-container/static-1.7432",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9516",
  "data-token-picker": "/data-token-picker/static-1.16565",
  "FileManagerLib": "/FileManagerLib/static-1.39493",
  "property-translator": "/property-translator/static-1.5490",
  "atom": "/atom/static-1.5169",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "purchase-motions-components": "/purchase-motions-components/static-1.6061",
  "salesImages": "/salesImages/static-1.526",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5596",
  "react-create-root-preference": "/react-create-root-preference/static-1.32",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-virtualized": "/react-virtualized/static-2.100",
  "ui-images": "/ui-images/static-2.1175",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4382",
  "floating-ui": "/floating-ui/static-1.57",
  "react-aria": "/react-aria/static-1.67",
  "trellis-assets": "/trellis-assets/static-1.2164",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3009",
  "foundations-theming-base": "/foundations-theming-base/static-1.3511",
  "stylex": "/stylex/static-1.34",
  "interframe": "/interframe/static-3.4854",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5856",
  "web-vitals": "/web-vitals/static-1.7",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.160",
  "chirp-fetch": "/chirp-fetch/static-1.1981",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4571",
  "react-flip-move": "/react-flip-move/static-1.72",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4747",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12601",
  "content-media-compositions": "/content-media-compositions/static-2.16608",
  "idb-keyval": "/idb-keyval/static-1.45",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4248",
  "magpie-lib": "/magpie-lib/static-1.5611",
  "magpie-types": "/magpie-types/static-1.5071",
  "media-bridge-lib": "/media-bridge-lib/static-1.19082",
  "video-data-lib": "/video-data-lib/static-1.35234",
  "bender-build-tools": "/bender-build-tools/static-1.3278",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3913",
  "superstore": "/superstore/static-1.4854",
  "feedback-loader": "/feedback-loader/static-1.29465",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9186",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8797",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28818",
  "sassPrefix": "/sassPrefix/static-1.157",
  "react-dnd-compat": "/react-dnd-compat/static-1.4708",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2591",
  "navigation-messaging": "/navigation-messaging/static-1.7572",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8268",
  "reselect": "/reselect/static-2.16",
  "commerce-products-lib": "/commerce-products-lib/static-1.9879",
  "crm-message-bus": "/crm-message-bus/static-1.43221",
  "growth-data-modal": "/growth-data-modal/static-1.5575",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4972",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4986",
  "calling-global-api": "/calling-global-api/static-1.64832",
  "calling-internal-common": "/calling-internal-common/static-1.31404",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66214",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58508",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3865",
  "crm-links": "/crm-links/static-1.6400",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4206",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13125",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9516",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8190",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "file-manager-components": "/file-manager-components/static-1.23853",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6984",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "hs-resources": "/hs-resources/static-1.269",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3654",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4289",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.728",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3758",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49065",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4034",
  "property-value-citations": "/property-value-citations/static-1.2517",
  "pulse": "/pulse/static-1.690",
  "smart-property-lib": "/smart-property-lib/static-1.7661",
  "tiered-pricing": "/tiered-pricing/static-1.1427",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11083",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3160",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2191",
  "navigation-components": "/navigation-components/static-1.18245",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.838",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7697",
  "ui-universal-auth": "/ui-universal-auth/static-1.9089",
  "batch-promise": "/batch-promise/static-1.1636",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17786",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10187",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5128",
  "base-ui": "/base-ui/static-1.12",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1034",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "audio-components": "/audio-components/static-1.6057",
  "FileManagerCore": "/FileManagerCore/static-1.39352",
  "FileManagerImages": "/FileManagerImages/static-1.37004",
  "video-components": "/video-components/static-1.13578",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1138",
  "purchase-motions-api": "/purchase-motions-api/static-1.6064",
  "signup-constants": "/signup-constants/static-1.19055",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8152",
  "usage-tracker-public": "/usage-tracker-public/static-1.7253",
  "reactive-lib": "/reactive-lib/static-1.820",
  "simple-logging-lib": "/simple-logging-lib/static-1.3145",
  "chatspot-core": "/chatspot-core/static-1.21736",
  "ContentUtils": "/ContentUtils/static-1.68623",
  "copilot-toolkit": "/copilot-toolkit/static-1.11370",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6673",
  "commerce-permissions": "/commerce-permissions/static-1.871",
  "customer-data-tracking": "/customer-data-tracking/static-1.6984",
  "products-iframe-lib": "/products-iframe-lib/static-1.8181",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10571",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1108",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2118",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.431",
  "calling-error-reporting": "/calling-error-reporting/static-1.31411",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11130",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6637",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1353",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7344",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9529",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.103",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4073",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6889",
  "persist-promise": "/persist-promise/static-1.3793",
  "event-emitter": "/event-emitter/static-1.1043",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.193",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "data-agent-kit": "/data-agent-kit/static-1.342",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10272",
  "fsm": "/fsm/static-1.3823",
  "policy-lib": "/policy-lib/static-1.6874",
  "react-tinymce": "/react-tinymce/static-1.55489",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10335",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54615",
  "tinymce-plugins": "/tinymce-plugins/static-1.57729",
  "tinymce-themes": "/tinymce-themes/static-1.56585",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2219",
  "user-context-client": "/user-context-client/static-1.4678",
  "nest": "/nest/static-1.325",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.885",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4631",
  "video-embed": "/video-embed/static-1.36068",
  "content-icons-ui": "/content-icons-ui/static-1.2251",
  "social-insights-client-types": "/social-insights-client-types/static-1.22301",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4907",
  "integrations-lib": "/integrations-lib/static-1.16456",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1023",
  "sales-views-client-types": "/sales-views-client-types/static-1.4351",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15055",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7698",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36130",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3658",
  "highcharts": "/highcharts/static-8.105",
  "trellis-story-utils": "/trellis-story-utils/static-1.4607",
  "storybook-react": "/storybook-react/static-1.34",
  "hub-http-contrib": "/hub-http-contrib/static-1.3136",
  "tinymce-data": "/tinymce-data/static-1.40700",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5304",
  "codemirror": "/codemirror/static-5.96",
  "layout-dnd-components": "/layout-dnd-components/static-1.12618",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11593",
  "react-codemirror": "/react-codemirror/static-1.10722",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15604",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9126",
  "outpost": "/outpost/static-1.4265",
  "flux-actions": "/flux-actions/static-1.343",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13871",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5700",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7876",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10457",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.603",
  "breeze-engine-core": "/breeze-engine-core/static-1.301",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68698",
  "layout-data-lib": "/layout-data-lib/static-1.9918",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3111",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.294",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.511",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.648",
  "slack-ui-library": "/slack-ui-library/static-1.10488",
  "advanced-menus-core": "/advanced-menus-core/static-1.15277",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12192",
  "ExportDialog": "/ExportDialog/static-6.10475",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34295",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15276",
  "simple-menus-lib": "/simple-menus-lib/static-1.16793"
}
};
